/**
 * Skyyrizon Bento — feature cell cycler.
 * Only Cell 1 cycles; Cells 2/3/4 are static.
 * Same safety pattern as the hero: pause on hover / offscreen / tab hidden /
 * reduced-motion.
 */
(function () {
  'use strict';

  function initFeature(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.sky-bento__feature-slide'));
    if (slides.length < 2) return;

    var interval = parseInt(root.getAttribute('data-interval'), 10);
    if (!interval || interval < 2000) interval = 8500;

    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var current = 0;
    var timer = null;
    var hovered = false;
    var visible = true;

    function activate(index) {
      var next = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === next); });
      current = next;
    }

    function step() { activate(current + 1); }

    function start() {
      if (prefersReducedMotion) return;
      if (hovered || !visible) return;
      stop();
      timer = window.setInterval(step, interval);
    }

    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    root.addEventListener('mouseenter', function () { hovered = true; stop(); });
    root.addEventListener('mouseleave', function () { hovered = false; start(); });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible) start(); else stop();
        });
      }, { threshold: 0.25 });
      io.observe(root);
    } else {
      start();
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-sky-bento-feature]');
    for (var i = 0; i < roots.length; i++) initFeature(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
